/* eslint-disable react/jsx-fragments */
import React, { Fragment } from 'react';

const Image = ({ className, alt, src, width, height, ...rest }) => (
	<Fragment>
		<img alt={alt} className={className} height={height} src={src} width={width} {...rest} />
	</Fragment>
);

export default Image;
